module App.Interfaces {
    export interface IRight {
        id: string;
        name: string;
    }
}

